import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import modules from './modules';

Vue.use(Vuex);

const storageMutations = ['session/authSuccess', 'session/checkingFinished', 'session/logout', 'globalState/setSessionItem'];
const accessPulso = localStorage.getItem('onlyAccessPulso');
/* IENTENTO BORRAR SESION */
// if (accessPulso) {
//   localStorage.removeItem('mics_session');
//   sessionStorage.removeItem('mics_session');
//   localStorage.removeItem('mics');
//   sessionStorage.removeItem('mics');
// }
/* IENTENTO BORRAR SESION */
console.log('VuexPersid', accessPulso, storageMutations);
console.log('Session or local', accessPulso ? {
  name: 'session',
  storage: window.sessionStorage,
} : {
  name: 'local',
  storage: window.localStorage,
});
const vuexSession = new VuexPersist({
  // strictMode: process.env.NODE_ENV === 'production',
  key: accessPulso ? 'mics' : 'mics_session',
  storage: accessPulso ? window.sessionStorage : window.localStorage,
  modules: ['session', 'globalState'],
  reducer: (state) => ({
    session: { storage: state.session.storage },
    globalState: { localSession: state.globalState.localSession },
  }),
  filter: (mutation) => storageMutations.includes(mutation.type),
});

const vuexLocal = new VuexPersist({
  // strictMode: process.env.NODE_ENV === 'production',
  key: 'mics',
  storage: window.localStorage,
  modules: ['login', 'globalState'],
  reducer: (state) => ({
    login: { storedUser: state.login.storedUser },
    globalState: { localState: state.globalState.localState },
  }),
});

const store = new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [vuexSession.plugin, vuexLocal.plugin],
});

export default store;

/* Update API Client credentials */
store.subscribe((mutation, state) => {
  if (storageMutations.includes(mutation.type) && Vue.api != null) {
    // eslint-disable-next-line
    const { access_key = null, token = null } = state.session.storage || {};
    Vue.api.setCredentials(access_key, token);
  }

  if (mutation.type === 'session/logout') {
    Object.keys(store.state).forEach((key) => {
      try {
        // eslint-disable-next-line no-underscore-dangle
        const $module = store._modules.root.getChild(key);
        // eslint-disable-next-line no-underscore-dangle
        if ($module != null && $module._rawModule.actions.reset != null) {
          store.dispatch(`${key}/reset`);
        }
      } catch (ex) {
        console.error('error dispatching reset action', ex);
      }
    });
  }
});
